<template>
  <q-page class="row justify-center items-center">
    <div class="text-center">
      <q-icon name="error_outline" style="font-size: 6em;" class="text-red-3 q-mb-sm" /><br>
      <div class="text-red-5 text-bold q-mb-md">Unable to continue due to network issues</div>
    </div>
    <portal to="footer">
      <BaseFooterFrame>
        <q-btn
          color="primary"
          size="16px"
          unelevated
          no-caps
          class="full-width q-btn--generic"
          @click="retryHandler"
          label="Retry" />
      </BaseFooterFrame>
    </portal>
  </q-page>
</template>

<script>
export default {
  name: 'ChunkLoadingTimeout',
  methods: {
    retryHandler () {
      this.$router.back()
      // this.$router.push({ name: 'index' }).catch(() => {})
    }
  }
}
</script>
